import React from "react";
import NavLink from "./NavLink";
import { NavigationLinksProps } from "../@types/types";

const NavigationLinks: React.FC<NavigationLinksProps> = ({ pages }) => {
  return (
    <>
      {pages.map((page, index) => (
        <NavLink key={index} page={page} />
      ))}
    </>
  );
};

export default NavigationLinks;
